module.exports = __webpack_public_path__ + "media/3.3c006334.mp3";